<template>
  <div
    class="range-element"
    :class="['range-element--'+Data.type]"
  >
    <h4
      v-if="Data.title"
      class="range-element__title g-title g-title--subtitle"
    >
      {{ Data.title }}
    </h4>

    <div
      ref="Slider"
      class="range-element__slider"
    >
      <div class="range-element__slider__bar" />
      <span class="range-element__fractions range-element__fractions--min">
        {{ Data.min }}
      </span>
      <div
        ref="SliderHandle"
        title="Adjust Water Budget"
        class="range-element__slider__handle"
        :style="{ transform: 'translateX('+RangeTranslateX+'px)'+'translateY(10px)' }"
        @mousedown="Mousedown"
        @touchstart.stop.prevent="Mousedown"
      >
        <font-awesome-icon :icon="['fas', 'arrows-alt-h']" />
        <div class="range-element__slider__indicator">
          {{ RangeValueModified }} <span class="range-element__slider__indicator__suffix">
            {{ Data.suffix }}
          </span>
        </div>
      </div>

      <span class="range-element__fractions range-element__fractions--max">
        {{ Data.max }}
      </span>
    </div>
  </div>
</template>

<script>
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

export default {
  name: 'RangeElement',
  components:
  {
    'font-awesome-icon': FontAwesomeIcon
  },
  props: {
    Data: {
      type: Object,
      default: function() {
        return{
          title: '',
          min: 0,
          max: 100,
          value: 50,
          suffix: '',
          type: 'flow'
        }
      }
    }
  },
  data() {
    return{
      RangeValue: this.Data.min,
      RangeTranslateX: 0,
      Value: undefined
    }
  },
  computed:
  {
    RangeValueModified() {
      return Math.round(this.Value)
    }
  },
  mounted() {
    this.Mousemove()
  },
  destroyed() {
    this.RemoveListeners()
  },
  methods: {
    Mousedown(E) {
      window.addEventListener('touchmove', this.Mousemove)
      window.addEventListener('touchend', this.Mouseup)
      window.addEventListener('mousemove', this.Mousemove)
      window.addEventListener('mouseup', this.Mouseup)
    },
    Mousemove: function Mousemove(E) {
      const mouseX = E
      ? E.type === 'touchmove'
        ? E.changedTouches[0].clientX
        : E.clientX
      : 0
      if(E) console.log(mouseX, E)
      const slider = this.$refs.Slider
      const sliderHandle = this.$refs.SliderHandle

      const sliderPosition = slider.getBoundingClientRect().left

      const sliderHandleWidth = sliderHandle.clientWidth
      const sliderHandleWidthHalf = sliderHandleWidth / 2

      const sliderMin = 0
      const sliderMax = slider.clientWidth
      const tempPosition = mouseX - sliderPosition

      if(this.Value === undefined) {
        this.RangeValue = (this.Data.value / ((this.Data.max - this.Data.min) + this.Data.min)) * sliderMax
      } else if(tempPosition >= sliderMin && tempPosition <= sliderMax) {
        this.RangeValue = tempPosition
      } else if(tempPosition < sliderMin) {
        this.RangeValue = sliderMin
      } else if(tempPosition > sliderMin) {
        this.RangeValue = sliderMax
      }

      this.RangeTranslateX = this.RangeValue - sliderHandleWidthHalf

      this.Value = this.Data.value = Math.round((this.RangeValue / sliderMax ) * (this.Data.max - this.Data.min) + this.Data.min) // -25 - 250
    },
    Mouseup: function Mouseup(E) {
      if(this.Data.emitFunctionNamed !== undefined) {
        this.$emit( this.Data.emitFunctionNamed, this.Value, E.type === 'touchmove' ? E.changedTouches[0] : E )
      }
      this.RemoveListeners()
    },
    RemoveListeners() {
      window.removeEventListener('touchmove', this.Mousemove)
      window.removeEventListener('touchend', this.Mouseup)
      window.removeEventListener('mousemove', this.Mousemove)
      window.removeEventListener('mouseup', this.Mouseup)
    }
  }
}
</script>

<style lang="scss">
.range-element {
  @include clearfix();
  $sliderHandleWidth: 40px;
  $sliderHandleHeight: 40px;
  padding: 0px 0 21px;
  margin: 10px 0;

  &__fractions {
    position: absolute;
    top: -15px;
    font-size: 11px;
    transform: translateX(-50%);
    color: $color-blue-marine;

    &--max {
      right: 0;
      transform: translateX(50%);
    }
  }

  &__slider {
    box-sizing: border-box;
    position: relative;
    width: 300px;
    margin-left: $sliderHandleWidth / 2;
    margin-top: 28px;

    &__bar {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 5px;
      background: $color-white;
      transform: translateY(-50%);

      .range-element--flow & {
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        transform: none;
        background: url("~@graphics/range_slider_segment.svg") no-repeat left bottom / contain;
        height: auto;
      }
    }

    &__handle {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: $sliderHandleWidth;
      height: $sliderHandleHeight;
      background: $color-white;
      border: 2px solid $color-grey-dark;
      color: $color-white;
      border-radius: 50%;
      cursor: pointer;
      user-select: none;

      .svg-inline--fa {
        font-size: 28px;
        user-select: none;
        background-color: darken($color-grey, 10);
        padding: 3px;
        margin: 20px;
        border: 3px solid $color-white;
        border-radius: 50%;
      }
    }

    &__indicator {
      position: absolute;
      bottom: -20px;
      left: 50%;
      color: $color-blue-marine;
      transform: translateX(-50%);
      // background: $color-blue-marine;
      font-family: $font-primary-semibold;

      &__suffix {
        position: absolute;
        top: 0;
        left: 100%;
        font-size: 12px;
      }
    }
  }
}
</style>
